<template>
  <div class="recordsBox">
    <FilterBar ref="filterBar" @search="onSearch"  @export="onExport"></FilterBar>
    <el-row class="btn_row" type="flex" justify="end">
      <div class="query-right">
        <ExportProgress ref="downloadDialog"></ExportProgress>
        <ExportExcel
          v-show="false"
          config-name="ExternalContactDetail"
          :excel-data="excelData"
          @emit="handleExportExcel"
        ></ExportExcel>
      </div>
    </el-row>

    <!-- table -->
    <div class="listContent">
      <el-table
        v-loading="loading"
        ref="recordTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        cell-class-name="table_cell"
      >
        <template slot="empty">
          <NoData></NoData>
        </template>
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="create_time" label="操作时间" width="180">
          <template slot-scope="scope">
            <span>
              {{
                scope.row.create_time
                  ? dateFormat(new Date(scope.row.create_time), 'YYYY-MM-dd HH:mm:SS')
                  : '--'
              }}
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="record_id" label="操作ID" width="80"></el-table-column>
        <el-table-column prop="create_by" label="操作人" width="100"></el-table-column>
        <el-table-column prop="external_userid" label="externalUserid"></el-table-column>
        <el-table-column prop="handover_userid" label="handoverUserid"></el-table-column>
        <el-table-column prop="handover_ntid" label="handoverNTID"></el-table-column>
        <el-table-column prop="handover_name" label="handoverName"></el-table-column>
        <el-table-column prop="takeover_userid" label="takeoverUserid"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span>{{ recordStatusList.find((item) => item.value == scope.row.status).label }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="transfer_success_msg"
          label="transferSuccessMsg"
          show-overflow-tooltip
          min-width="120"
        ></el-table-column>
        <el-table-column prop="err_msg" label="失败原因" show-overflow-tooltip></el-table-column>
      </el-table>
      <el-pagination
        v-if="tableData.length > 0"
        class="pagination"
        style="background-color: #ffffff"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="g_pageSizesConfig"
        :total="total"
        :page-size="size"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import FilterBar from './filterBar.vue';
import { dateFormat } from '@/utils/time';
import NoData from '@/components/no-data';
import { recordStatusList } from '../constrants';
import { sstore } from '@/libs/utils/util';
import {ExternalTransferDetail} from '@/api/transferContacts';
import ExportExcel from '@/components/export-excel';
import ExportProgress from '@/components/export-progress';

export default {
  name: 'Records',
  components: {
    NoData,
    FilterBar,
    ExportProgress,
    ExportExcel,
  },
  data() {
    return {
      recordStatusList,
      dateFormat,
      loading: false,
      tableData: [],
      currentPage: 1,
      size: this.g_pageSizeDefault,
      total: 0,
      record_id: '',
      excelData:[],
    };
  },
  created() {
    this.record_id = sstore.getItem('record_id');
  },
  mounted() {
    if (this.size == null) {
      this.size = this.g_pageSizeDefault;
    }
    this.getTableData();
  },
  destroyed() {
    sstore.removeItem('record_id');
  },
  methods: {
    getPayload(page,pageSize){
      return {
        page: page,
        page_size: pageSize,
        name: this.$refs.filterBar.form.operator,
        start_time: this.$refs.filterBar.date[0] != null ? `${this.$refs.filterBar.date[0]}  00:00:00` : "",
        end_time: this.$refs.filterBar.date[1] != null ? `${this.$refs.filterBar.date[1]}  23:59:59` : "",
        record_id: this.record_id,
        status: this.$refs.filterBar.form.status,
        external_userid: this.$refs.filterBar.form.external_userid,
        handover_userid: this.$refs.filterBar.form.handover_userid,
        takeover_userid: this.$refs.filterBar.form.takeover_userid,
        handover_ntid: this.$refs.filterBar.form.handover_ntid,
      };
    },
    async handleExportExcel() {
      console.log("handleExportExcel")
      this.$refs.downloadDialog.openDialog();
      this.$refs.downloadDialog.startRidiculousProgress(30);
      const res = await ExternalTransferDetail(this.getPayload(1,1))
      if (res.total > 50000) {
        this.$message.warning(`最大支持导出5万条数据，当前数据${res.total}条，请重新筛选`);
        this.$refs.downloadDialog.abortProgress();
      } else {
        const res = await ExternalTransferDetail(this.getPayload(1,50000))
        if (res.err_code === 0) {
          this.excelData = res.list.map(item=>{
            let statusMsg = recordStatusList[0].label;
            recordStatusList.forEach(statusItem=>{
                if(statusItem.value == item.status){
                  statusMsg = statusItem.label;
                }
            })
            item.status = statusMsg;
            return item;
          })
          this.$refs.downloadDialog.finishProgress(500);
        }
      }
      this.loading = false;
      return;
    },
    async getTableData() {
      this.loading = true;
      await this.$nextTick();
      const response = await ExternalTransferDetail(this.getPayload(
        this.currentPage, this.size || this.g_pageSizeDefault,
      ));
      if (response.err_code === 0) {
        this.total = response.total;
        this.tableData = response.list;
        console.log(response.list);
      }
      this.loading = false;
    },
    onSearch() {
      this.currentPage = 1;
      this.getTableData();
    },
    onExport(){
      this.handleExportExcel()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.size = val;
      this.getTableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.recordsBox {
  .btn_row {
    padding: 16px 0;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
  }
  .pagination {
    text-align: right;
    margin: 10px 0;
  }
}
</style>
